export function loadScript(options) {
    return new Promise(function (resolve, reject) {
        try {
            var scriptElement = document.createElement('script');
            scriptElement.type = options.type || 'text/javascript';
            scriptElement.async = options.async || true;
            scriptElement.defer = options.defer || false;
            scriptElement.src = options.url;
            if (options.id) {
                scriptElement.id = options.id;
            }
            scriptElement.addEventListener('load', function () {
                resolve({ isSuccessful: true });
            });
            scriptElement.addEventListener('error', function () {
                reject({
                    isSuccessful: false,
                    message: "Failed to load the script ".concat(options.url),
                });
            });
            document[options.parent || 'body'].appendChild(scriptElement);
        }
        catch (error) {
            reject({
                isSuccessful: false,
                message: JSON.stringify(error),
            });
        }
    });
}
